import { Fragment, Suspense } from 'react';

import { useGetCcrcDetailData } from '../../model';

import './ccrcDetail.css';

export const CcrcDetail = ({ params, handleSubmit }) => {
  return (
    <Suspense>
      <Body params={params} handleSubmit={handleSubmit} />
    </Suspense>
  );
};

const Body = ({ params, handleSubmit }) => {
  const { mainTitl, mainTitlDtl, subCcrc, desc } = useGetCcrcDetailData(params);
  return (
    <>
      <div className='container-wrap ccrc-detail-wrap'>
        <div className='content-area'>
          <div className='agreement-privacy'>
            <h2 className='h2'>{mainTitl}</h2>
            <div className='privacy-item'>
              <p className='b4'>
                {mainTitlDtl.split('\n').map((line, index) => {
                  return (
                    <Fragment key={index}>
                      {line}
                      <br />
                    </Fragment>
                  );
                })}
              </p>
            </div>
            {subCcrc?.map(({ subTitl, subTitlDtl, subTitlDtlLinkUrl, subTitlDtlLinkYn }) => {
              return (
                <div className='privacy-item' key={subTitl}>
                  <p className='b1'>{subTitl}</p>
                  {subTitlDtlLinkUrl && subTitlDtlLinkYn === 'Y' ? (
                    <p className='b4'>
                      <a href={subTitlDtlLinkUrl}>{subTitlDtl}</a>
                    </p>
                  ) : (
                    <p className='b4'>
                      {subTitlDtl.split('\n').map((line, index) => {
                        return (
                          <Fragment key={index}>
                            {line} <br />
                          </Fragment>
                        );
                      })}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <p className='b4'>
            {desc.split('\n').map((line, index) => {
              return (
                <Fragment key={index}>
                  {line} <br />
                </Fragment>
              );
            })}
          </p>
          <div className='btm-area gradient-btm'>
            <button className='btn btm-btn-primary' onClick={handleSubmit}>
              <span className='btn-txt-01'>확인</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
